import { messagesRoot } from "./constants";

class ApiAssignMessage {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (messageId, ownerEmail) => {
    const apiRoute = messagesRoot + "AssignMessage";
    let params = {
      messageId: messageId,
      mailbox: ownerEmail
    };
    return await this.apiClass.CallApi("putQuery", apiRoute, params);
  };
}

export default ApiAssignMessage;
